/**
 * Shared React Flow interaction props for the RDV and Data Mart modelling canvases. Spread these
 * onto both `<ReactFlow>` elements so pan / zoom / selection behavior cannot drift between the two
 * screens (it has, repeatedly — left-drag pan vs box-select, zoom range).
 *
 * Behavior: left-drag pans (React Flow default), two-finger trackpad scroll pans (panOnScroll),
 * Shift-drag box-selects, Meta/Ctrl/Shift multi-selects, zoom 0.2–2.5.
 *
 * NOT included here (intentionally per-screen, behavior differs): `connectionMode` (RDV uses Loose;
 * DM does not), node/edge handlers, fitView options, className/style.
 */
export const SHARED_CANVAS_INTERACTION_PROPS = {
  panOnScroll: true,
  selectionKeyCode: "Shift" as const,
  multiSelectionKeyCode: ["Meta", "Control", "Shift"] as string[],
  minZoom: 0.2,
  maxZoom: 2.5
};
